<template>
  <section class="user-detail-container">
    <base-header v-bind="headers"
      v-on:handleReset="handleHeaderReset"
    />
    <base-form
      v-bind="form"
      v-on:handleConfirm="handleConfirm"
    ></base-form>
    <form-dialog
    title="重置密码"
      ref="updateDialog"
      :loading="updateFormLoading"
      :form="updateForm"
      :rules="updateRules"
      :formItems="updateFormItems"
      :buttons="updateButtons"
      v-on:handleConfirm="handleConfirmUpdate"
    ></form-dialog>
  </section>
</template>
<script>
import user from './user'

export default {
  name: 'userCreate',
  mixins: [user],
  data () {
    var email = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else {
        var params = {
          mail: value,
          id: this.form.form.id
        }
        this.$request.fetchSysMailUnique(params).then(res => {
          if (res.code === 200) {
            if (res.data) {
              callback()
            } else {
              callback(new Error('邮箱已存在'))
            }
          } else {
            callback(new Error(res.message))
          }
        })
      }
    }
    var phone = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else {
        var params = {
          phone: value,
          id: this.form.form.id
        }
        this.$request.fetchSysPhoneUnique(params).then(res => {
          if (res.code === 200) {
            if (res.data) {
              callback()
            } else {
              callback(new Error('手机号码已存在'))
            }
          } else {
            callback(new Error(res.message))
          }
        })
      }
    }
    return {
      backUrl: '/memberManage/user/index',
      headers: {
        buttons: [],
        title: '编辑投稿人',
        showAlertIcon: false,
        content: ''
      },
      form: {
        api: 'fetchMemberManageUserDetail',
        params: {
          id: ''
        },
        form: {
          'id': '',
          'psw': '',
          'realname': '',
          'usePhone': '',
          'email': '',
          'gender': '',
          'postAddress': '',
          'company': '',
          'job': ''
        },
        formItems: [
          {
            prop: 'username',
            label: '用户名：',
            maxlength: 20,
            type: 'text'
          },
          {
            prop: 'realname',
            label: '真实姓名：',
            maxlength: 50,
            placeholder: '请输入您的真实姓名'
          },
          {
            type: 'radio',
            prop: 'gender',
            label: '性别：',
            options: [
              {
                label: '男',
                value: 1
              },
              {
                label: '女',
                value: 2
              }
            ]
          },
          {
            prop: 'usePhone',
            label: '手机号：',
            maxlength: 11
          },
          {
            prop: 'email',
            label: '电子邮箱：',
            maxlength: 30
          },
          {
            prop: 'postAddress',
            label: '邮寄地址：'
          },
          {
            prop: 'company',
            label: '所在单位：'
          },
          {
            prop: 'job',
            label: '学历/职称：'
          }
        ],
        rules: {
          // username: [
          //   this.$rules.required()
          // ],
          email: [
            this.$rules.email(),
            this.$rules.required(),
            { validator: email, trigger: 'blur' }
          ],
          usePhone: [
            this.$rules.mobile(),
            this.$rules.required(),
            { validator: phone, trigger: 'blur' }
          ],
          realname: [
            this.$rules.required()
          ],
          gender: [
            this.$rules.required()
          ],
          postAddress: [
            this.$rules.required()
          ],
          company: [
            this.$rules.required()
          ],
          job: [
            this.$rules.required()
          ]
        },
        submitBtns: [{
          text: '保存',
          subType: 'submit',
          notDisabled: true
        }]
      }
    }
  },
  inject: ['removeTab'],
  methods: {
    // 发送请求事件
    handleHeaderReset (data, btn) {
      this.updateForm.username = this.form.form.username
      this.updateForm.id = this.form.form.id
      this.$refs.updateDialog.showDialog()
    },
    handleConfirm (data) {
      this.form.loading = true
      this.$request.fetchMemberManageUserUpdate(data).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          setTimeout(() => {
            this.removeTab(this.$route.fullPath)
            this.$routerLink(this.backUrl, 'list')
          }, 500)
        }
        this.hideFormLoading()
      }).catch(this.hideFormLoading)
    },
    getUserData () {
      const { id } = this.$route.query
      if (id && id !== this.form.params.id) {
        this.form.params.id = id
        this.fetchFormApi()
      }
    },
    fetchFormCallBack (res) {
      if (res.code === 200) {
        this.form.form = Object.assign({}, this.form.form, res.data)
        this.form.form.roleid = res.data.roleIds
        this.form.form.username = res.data.username
        this.form.form.email = res.data.email
        this.form.form.postAddress = res.data.otherExt.postAddress
        this.form.form.company = res.data.otherExt.company
        this.form.form.job = res.data.otherExt.job
        this.form.form.gender = res.data.userExt.gender === 3 ? '' : res.data.userExt.gender || ''
        this.form.form.realname = res.data.userExt.realname || ''
        this.form.form.usePhone = res.data.telephone
        this.form.form.enabled = res.data.enabled
        this.form.form.id = res.data.id
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getUserData()
    })
  },
  watch: {
    '$route': function (newRoute, oldRoute) {
      if (newRoute.name === 'userCreate') {
        this.getUserData()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box-items{
    padding: 0 9px;
  }
</style>
